import React from 'react';
import BulkPurchaseInvoiceFlow from '@Components/PurchaseInvoiceCreation/BulkPurchaseInvoice/BulkPurchaseInvoiceFlow';

const CreateBulkPurchaseInvoice = () => {
  return (
    <div>
      <BulkPurchaseInvoiceFlow />
    </div>
  );
};

export default CreateBulkPurchaseInvoice;
